class WheelAccordion {
  constructor(element) {
    this.element = element;
    this.blocks = this.element.querySelectorAll('[data-element="accordion-block"]');
    this.buttons = this.element.querySelectorAll('[data-element="accordion-button"]');
    this.firstBlock = this.blocks[0];
    this.lastBlock = this.blocks[this.blocks.length - 1];
  }

  init() {
    this.blocks.forEach((block) => {
      block.addEventListener('keydown', this.onKeydown.bind(this));
    });
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this, button));
    });
  }

  onButtonClick(button) {
    const block = button.closest('[data-element="accordion-block"]');

    if (true === block.classList.contains('wheel-accordion__accordion-block--open')) {
      block.classList.remove('wheel-accordion__accordion-block--open');
      block.setAttribute('aria-expanded', false);
      block.setAttribute('aria-selected', false);
      block.setAttribute('tabindex', -1);
    } else {
      block.classList.add('wheel-accordion__accordion-block--open');
      block.setAttribute('aria-expanded', true);
      block.setAttribute('aria-selected', true);
      block.setAttribute('tabindex', 0);
    }
  }

  onKeydown(event) {
    const currentBlock = event.currentTarget;
    let flag = false;

    switch (event.key) {
    case 'ArrowUp':
    case 'ArrowLeft':
      this.moveFocusToPreviousBlock(currentBlock);
      flag = true;
      break;

    case 'ArrowDown':
    case 'ArrowRight':
      this.moveFocusToNextBlock(currentBlock);
      flag = true;
      break;

    case 'Home':
      this.moveFocusToBlock(this.firstBlock);
      flag = true;
      break;

    case 'End':
      this.moveFocusToBlock(this.lastBlock);
      flag = true;
      break;

    default:
      break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  moveFocusToBlock(currentBlock) {
    currentBlock.querySelector('[data-element="accordion-button"]').focus();
  }

  moveFocusToPreviousBlock(currentBlock) {
    if (currentBlock === this.firstBlock) {
      this.moveFocusToBlock(this.lastBlock);
    } else {
      this.moveFocusToBlock(currentBlock.previousElementSibling);
    }
  }

  moveFocusToNextBlock(currentBlock) {
    if (currentBlock === this.lastBlock) {
      this.moveFocusToBlock(this.firstBlock);
    } else {
      this.moveFocusToBlock(currentBlock.nextElementSibling);
    }
  }
}

const wheelAccordion = {
  init() {
    const wheelAccordionItems = document.querySelectorAll('[data-module="wheel-accordion"]');

    if (wheelAccordionItems && wheelAccordionItems.length > 0) {
      wheelAccordionItems.forEach((item) => {
        const wheelAccordionItem = new WheelAccordion(item);
        wheelAccordionItem.init();
      });
    }
  },
};

export default wheelAccordion;
